/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiProjectSubscriptionPaymentFromJSON, ApiProjectSubscriptionPaymentToJSON, } from './ApiProjectSubscriptionPayment';
import { ApiProjectSubscriptionStatusFromJSON, ApiProjectSubscriptionStatusToJSON, } from './ApiProjectSubscriptionStatus';
import { ApiSimpleProjectFromJSON, ApiSimpleProjectToJSON, } from './ApiSimpleProject';
import { ApiSimpleSubscriptionFromJSON, ApiSimpleSubscriptionToJSON, } from './ApiSimpleSubscription';
export function ApiSimpleProjectSubscriptionFromJSON(json) {
    return ApiSimpleProjectSubscriptionFromJSONTyped(json, false);
}
export function ApiSimpleProjectSubscriptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'external': !exists(json, 'external') ? undefined : json['external'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isAnnual': !exists(json, 'isAnnual') ? undefined : json['isAnnual'],
        'nextPaymentAt': !exists(json, 'nextPaymentAt') ? undefined : (new Date(json['nextPaymentAt'])),
        'paymentLink': !exists(json, 'paymentLink') ? undefined : json['paymentLink'],
        'paymentLinkQr': !exists(json, 'paymentLinkQr') ? undefined : json['paymentLinkQr'],
        'payments': !exists(json, 'payments') ? undefined : (json['payments'].map(ApiProjectSubscriptionPaymentFromJSON)),
        'productName': !exists(json, 'productName') ? undefined : json['productName'],
        'project': !exists(json, 'project') ? undefined : ApiSimpleProjectFromJSON(json['project']),
        'seenAt': !exists(json, 'seenAt') ? undefined : (new Date(json['seenAt'])),
        'status': !exists(json, 'status') ? undefined : ApiProjectSubscriptionStatusFromJSON(json['status']),
        'subscription': !exists(json, 'subscription') ? undefined : ApiSimpleSubscriptionFromJSON(json['subscription']),
    };
}
export function ApiSimpleProjectSubscriptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'external': value.external,
        'id': value.id,
        'isAnnual': value.isAnnual,
        'nextPaymentAt': value.nextPaymentAt === undefined ? undefined : (value.nextPaymentAt.toISOString()),
        'paymentLink': value.paymentLink,
        'paymentLinkQr': value.paymentLinkQr,
        'payments': value.payments === undefined ? undefined : (value.payments.map(ApiProjectSubscriptionPaymentToJSON)),
        'productName': value.productName,
        'project': ApiSimpleProjectToJSON(value.project),
        'seenAt': value.seenAt === undefined ? undefined : (value.seenAt.toISOString()),
        'status': ApiProjectSubscriptionStatusToJSON(value.status),
        'subscription': ApiSimpleSubscriptionToJSON(value.subscription),
    };
}
